module.exports = __webpack_public_path__ + "img/plus.a43e52ef.svg";